class ProductJourney extends HTMLElement {
  constructor() {
    super();

    this.journeySlider = this.querySelector(".journey-carousel");

    this.items = this.journeySlider.querySelector(".journey-carousel__slides");
    this.prev = this.journeySlider.querySelector(".slider-button--prev");
    this.next = this.journeySlider.querySelector(".slider-button--next");

    this.isTouchDevice = (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );

    this.isMouseDown = null;

    this.scaleModifier = this.dataset.scaleModifier || 1.1
    this.posX1 = 0;
    this.posX2 = 0;
    this.threshold = 100;

    this.slides = this.journeySlider.querySelectorAll(".slider__slide");
    this.slidesLength = this.slides.length;

    // Hover content
    this.slides.forEach(slide => {
      const modal = slide.querySelector(".journey-carousel__hover-content");
      const button = slide.querySelector(".journey-carousel__hover-button");
      if (button) {
        const toggleModal = (e) => {
          e.preventDefault();  // Prevents double-firing in some cases
          modal?.classList.toggle("active");
        };

        button.addEventListener("click", toggleModal);
        button.addEventListener("touchend", toggleModal);
      }
    });

    const images = [...document.querySelectorAll(".journey-carousel img")];
    // Ensures relevant images in journey are loaded before setting the height
    const firstImage = images[0];
    const secondImage = images[1];
    const lastImage = images[images.length - 1];

    const checkImagesLoaded = () => {
      if (firstImage.complete && secondImage.complete && lastImage.complete) {
        this.slideSizeChange();
        window.addEventListener("resize", () => {
          this.slideSizeChange();
        });
      }
    };
    if (firstImage.complete && secondImage.complete && lastImage.complete) {
      checkImagesLoaded();
    } else {
      [firstImage, secondImage, lastImage].forEach(img => {
        if (!img.complete) {
          img.addEventListener("load", checkImagesLoaded);
        }
      });
    }


    this.items.style.left = -1 * (this.slideSize * 2) + "px";

    const firstSlide = this.slides[0];
    const secondSlide = this.slides[1];
    const secondLastSlide = this.slides[this.slidesLength - 2];
    const lastSlide = this.slides[this.slidesLength - 1];
    const cloneFirst = firstSlide.cloneNode(true);
    cloneFirst.classList.add("clone");
    cloneFirst.classList.remove("active");
    cloneFirst.setAttribute("aria-hidden", true);

    const cloneSecond = secondSlide.cloneNode(true);
    cloneSecond.classList.add("clone");
    cloneSecond.classList.remove("active");
    cloneSecond.setAttribute("aria-hidden", true);

    const cloneSecondLast = secondLastSlide.cloneNode(true);
    cloneSecondLast.classList.add("clone");
    cloneSecondLast.classList.remove("active");
    cloneSecondLast.setAttribute("aria-hidden", true);

    const cloneLast = lastSlide.cloneNode(true);
    cloneLast.classList.add("clone");
    cloneLast.classList.remove("active");
    cloneLast.setAttribute("aria-hidden", true);

    cloneLast.classList.add("previous");
    this.slides[1].classList.add("next");
    this.index = 0;
    this.currentIndex = 0;
    this.allowShift = true;

    // Clone first and last slide
    this.items.appendChild(cloneFirst);
    this.items.appendChild(cloneSecond);
    this.items.insertBefore(cloneLast, firstSlide);
    this.items.insertBefore(cloneSecondLast, cloneLast);
    this.classList.add("loaded");

    this.mainSlides = this.journeySlider.querySelectorAll(
      ".slider__slide:not(.clone)"
    );

    // set new active slide
    this.newActiveSlide = this.items.querySelector(".active");

    if (this.isTouchDevice) {
      this.journeySlider.addEventListener("touchstart", this.dragStart.bind(this));
      this.journeySlider.addEventListener("touchend", this.dragEnd.bind(this));
      this.journeySlider.addEventListener("touchmove", this.dragAction.bind(this));
    } else {
      this.journeySlider.addEventListener("mousedown", this.dragStart.bind(this));
      this.journeySlider.addEventListener("mouseleave", this.dragEnd.bind(this));
      this.journeySlider.addEventListener("mouseup", this.dragEnd.bind(this));
      this.journeySlider.addEventListener("mousemove", this.dragAction.bind(this));
    }

    // Click events
    this.prev.addEventListener("click", () => {
      this.shiftSlide(-1);
    });
    this.next.addEventListener("click", () => {
      this.shiftSlide(1);
    });

    // Transition events
    this.items.addEventListener("transitionend", () => {
      this.checkIndex();
      this.setNewActiveSlide(this.newActiveSlide);
      this.setActiveJourney(this.index);
    });

    this.items.addEventListener("click", (e) => {
      if (e.target.classList.contains("next")) {
        this.shiftSlide(1);
      } else if (e.target.classList.contains("previous")) {
        this.shiftSlide(-1);
      }
    });
  }

  shiftSlide(dir, action) {
    this.items.classList.add("shifting");
    if(this.querySelector('.journey-carousel__hover-content.active')) {
      this.querySelector('.journey-carousel__hover-content.active').classList.remove('active');
    }

    if (this.allowShift) {
      if (!action) {
        this.posInitial = this.items.offsetLeft;
      }

      const currentActive = this.items.querySelector(".active");
      if (currentActive) {
        this.currentIndex = currentActive.getAttribute("data-index");
      }

      this.items.querySelector(".previous").removeEventListener("click", () => {
        this.shiftSlide(-1);
      });
      this.items.querySelector(".next").removeEventListener("click", () => {
        this.shiftSlide(1);
      });

      this.slides.forEach((slide) => {
        slide.classList.remove("active");
        slide.classList.remove("next");
        slide.classList.remove("previous");
      });

      if (dir == 1) {
        this.items.style.left = this.posInitial - this.slideSize + "px";
        this.index++;

        let nextIndex = parseInt(this.currentIndex) + 1;
        if (nextIndex == this.slidesLength) {
          nextIndex = 0;
        }
        this.newActiveSlide = this.mainSlides[nextIndex];
        this.mainSlides[nextIndex].previousElementSibling.classList.add(
          "previous"
        );
        this.mainSlides[nextIndex].nextElementSibling.classList.add("next");
      } else if (dir == -1) {
        this.items.style.left = this.posInitial + this.slideSize + "px";
        this.index--;

        let nextIndex = parseInt(this.currentIndex) - 1;
        if (nextIndex < 0) {
          nextIndex = this.slidesLength - 1;
        }
        this.newActiveSlide = this.mainSlides[nextIndex];
        this.mainSlides[nextIndex].previousElementSibling.classList.add(
          "previous"
        );
        this.mainSlides[nextIndex].nextElementSibling.classList.add("next");
      }
    }

    this.allowShift = false;
  }

  checkIndex() {
    this.items.classList.remove("shifting");

    if (this.index == -1) {
      this.items.style.left =
        -((this.slidesLength + 1) * this.slideSize) + "px";
      this.index = this.slidesLength - 1;
    }

    if (this.index == this.slidesLength) {
      this.items.style.left = -(1 * (this.slideSize * 2)) + "px";
      this.index = 0;
    }

    this.allowShift = true;
  }

  setNewActiveSlide(newActiveSlide) {
    newActiveSlide.classList.add("active");
  }

  slideSizeChange() {
    this.slideSize = this.slides[0].offsetWidth;
    this.slides.forEach((slide) => {
      slide.style.height = "auto";
    });

    const windowWidth = window.innerWidth;
    let heightModifier = 1;
    if (windowWidth >= 768) {
      heightModifier = this.scaleModifier;
    }

    let height = 0;
    this.slides.forEach(slide => {
      const currentHeight = slide.offsetHeight;
      if (currentHeight > height) {
        height = currentHeight;
      }
    });


    // This height should be dynamic depending on the active slide?
    document.documentElement.style.setProperty(
      "--journey-slider-width",
      this.slideSize
    );
    document.documentElement.style.setProperty(
      "--journey-slider-height",
      height * heightModifier
    );

    this.slides.forEach((slide) => {
      slide.style.height = "var(--journey-slider-height)";
    });

    this.items.style.left = -((this.index + 2) * this.slideSize) + "px";
  }

  setActiveJourney(index) {
    const journeyBlocks = this.querySelectorAll(".journey");
    if (journeyBlocks.length) {
      journeyBlocks.forEach((block, i) => {
        block.classList.toggle("active", i == index);
      });
    }
  }

  dragStart(e) {
    if (!this.isTouchDevice) {
      this.isMouseDown = true;
    }

    e = e || window.event;
    // Record the starting positions for both X and Y.
    if (e.type === "touchstart") {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.posX1 = e.touches[0].clientX;
    } else {
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.posX1 = e.clientX;
      document.onmouseup = this.dragEnd.bind(this);
      document.onmousemove = this.dragAction.bind(this);
    }
    this.posInitial = this.items.offsetLeft;
    // This flag will be set to true if the gesture is determined to be horizontal,
    // false if vertical, and remains null until the direction is determined.
    this.isHorizontalDrag = null;
    this.setAttribute("dragging", "");
  }

  dragAction(e) {
    if (!this.isTouchDevice && !this.isMouseDown) return;

    e = e || window.event;
    let currentX, currentY;

    if (e.type === "touchmove") {
      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
    } else {
      currentX = e.clientX;
      currentY = e.clientY;
    }

    // Calculate differences from the starting positions.
    const diffX = currentX - this.startX;
    const diffY = currentY - this.startY;

    // If the drag direction hasn't been determined yet, decide now.
    if (this.isHorizontalDrag === null) {
      if (Math.abs(diffX) > Math.abs(diffY)) {
        this.isHorizontalDrag = true;
        // Since horizontal dragging is intended, prevent default to handle slider movement.
        e.preventDefault();
      } else {
        if (this.isTouchDevice) {
          this.isHorizontalDrag = false;
        }
      }
    } else if (this.isHorizontalDrag) {
      // Already determined horizontal; continue to prevent default.
      e.preventDefault();
    }

    // Only update horizontal dragging if the gesture is horizontal.
    if (this.isHorizontalDrag) {
      this.posX2 = this.posX1 - currentX;
      this.posX1 = currentX;
      this.items.style.left = this.items.offsetLeft - this.posX2 + "px";
    }
  }

  dragEnd(e) {
    if (!this.isTouchDevice) {
      this.isMouseDown = false;
    }

    // Only process slider movement if a horizontal drag was detected.
    if (this.isHorizontalDrag) {
      this.posFinal = this.items.offsetLeft;
      if (this.posFinal - this.posInitial < -this.threshold) {
        this.shiftSlide(1, "drag");
      } else if (this.posFinal - this.posInitial > this.threshold) {
        this.shiftSlide(-1, "drag");
      } else {
        this.items.style.left = this.posInitial + "px";
      }
    }

    document.onmouseup = null;
    document.onmousemove = null;
    // Reset the flag for the next drag.
    this.isHorizontalDrag = null;
    this.removeAttribute("dragging");
  }

}

customElements.define("product-journey", ProductJourney);
